import { Controller } from "@hotwired/stimulus"
import BrandSelectionController from "./brand_selection_controller"

export default class GiftModeToggleController extends Controller {
  static targets = ["modeField", "modeButton", "brandedPane", "catalogPane"]
  static values = { initialMode: String }

  declare readonly modeFieldTarget: HTMLInputElement
  declare readonly modeButtonTargets: HTMLButtonElement[]
  declare readonly brandedPaneTarget: HTMLElement
  declare readonly catalogPaneTarget: HTMLElement
  declare initialModeValue: string

  connect(): void {
    this.applyMode(this.initialModeValue || "branded", { silent: true })
  }

  setMode(event: { params: { mode: string } }): void {
    this.applyMode(event.params.mode)
  }

  catalogValidityChanged(event: CustomEvent): void {
    if (this.modeFieldTarget.value !== "catalog") return
    this.setSubmitDisabled(!event.detail.valid)
  }

  private applyMode(mode: string, { silent = false } = {}): void {
    this.modeFieldTarget.value = mode
    this.brandedPaneTarget.classList.toggle("d-none", mode !== "branded")
    this.catalogPaneTarget.classList.toggle("d-none", mode !== "catalog")
    this.modeButtonTargets.forEach((btn) => {
      const isActive = btn.dataset.giftModeToggleModeParam === mode
      btn.classList.toggle("btn-primary", isActive)
      btn.classList.toggle("btn-primary-subtle", !isActive)
    })

    if (!silent) {
      if (mode === "catalog") {
        this.brandSelectionController?.disableSubmitManagement()
        this.setSubmitDisabled(true)
      } else {
        this.brandSelectionController?.enableSubmitManagement()
      }
    }
  }

  private setSubmitDisabled(disabled: boolean): void {
    this.brandSelectionController?.setSubmitDisabled(disabled)
  }

  private get brandSelectionController() {
    const el = this.element.closest('[data-controller~="brand-selection"]')
    if (!el) return null
    return this.application.getControllerForElementAndIdentifier(el, "brand-selection") as BrandSelectionController | null
  }
}
